import * as moment from 'moment';

import {JSonSerializer} from "../../../model/JSonSerializer";
import {CustomCode} from "../../../model/common.model";
import {MemoWorkShift} from "../../../halfGod/memo/model/MemoWorkShift";
import {MemoVacationRequest} from "../../../halfGod/memo/model/MemoVactionRequest";
import {
  ApprovableBankTypeRequestWithRecipientId
} from "../../../halfGod/memo/model/ApprovableBankTypeRequestWithRecipientId";
import {ApprovableFamilyDayRequest} from "./ApprovableFamilyDayRequest";
import {
  ApprovableFamilyDayRequestWithRecipientId
} from "../../../halfGod/memo/model/ApprovableFamilyDayRequestWithRecipientId";

export class MemoAggregation{

  info = new MemoInformation();
  status = new Array<MemoEmployeeStatus>();
  recipients = new Array<MemoEmployee>();
  related = new Array<MemoAggregation>();
  hasAttachment = false;

  // Extension
  workShift = new  MemoWorkShift();
  vacationRequest = new MemoVacationRequest();
  bankTypeRequest = new ApprovableBankTypeRequestWithRecipientId();
  familyDayRequest = new ApprovableFamilyDayRequestWithRecipientId();




  _createFromArray(propertyName: string, data: any) {
    const serializer = new JSonSerializer();
    if ('status' === propertyName) {
      for (const bean of <MemoEmployeeStatus[]> data) {
        const tmp = new MemoEmployeeStatus();
        serializer.deserialize(bean, tmp);
        this.status.push(tmp);
      }
    }
    if ('recipients' === propertyName) {
      for (const bean of <MemoEmployee[]> data) {
        const tmp = new MemoEmployee();
        serializer.deserialize(bean, tmp);
        this.recipients.push(tmp);
      }
    }
    if ('related' === propertyName) {
      for (const bean of <MemoAggregation[]> data) {
        const tmp = new MemoAggregation();
        serializer.deserialize(bean, tmp);
        this.related.push(tmp);
      }
    }
  }


  removeMemoEmployeeStatus(id: number):boolean{
    if (this.status){
      for (let idx=this.status.length-1;idx>=0; idx--){
        const bean = this.status[idx];
        if (id === bean.id){
          this.status.splice(id,1);
          return true;
        }
      }
    }
    return false;
  }

  findRecipient(employeeId: string): MemoEmployee {
    for (let mr of this.recipients) {
      if (mr.employeeCode === employeeId) {
        return mr;
      }
    }
    return null;
  }


  get recipientsAsList(): string{
    let res: string = '';
    for (let recipient of this.recipients){
      if (res.length > 0) {
        res += ', ';
      }
      res += recipient.employeeFullName;
    }
    return res;
  }


  isMemoCompletlyDeleted(employeeId: string):boolean{
      let res = this.isMemoDeletedByEmployee(employeeId);
      if (res){
        for (const bean of this.related){
          if (!bean.isMemoDeletedByEmployee(employeeId)){
            res = false;
            break;
          }
        }
      }
     return res;
  }


  getMostRecentDate():Date{
    let res = this.info.created;
    for (const memo of this.related){
      const tmp = memo.getMostRecentDate();
      if (moment(res).isBefore(tmp)){
        res = tmp;
      }
    }
    return res;
  }

  /**
   * A memo authored by the current user (employeeId) will not be considered new.
   * @param employeeId
   */
  getFirstUnRead(employeeId: string):MemoAggregation{
    if (!this.isMemoAuthoredBy(employeeId)){
      // console.log('Verifying that memo hasn\'t been authored by the current employee');
      if (!this.isMemoReadByEmployee(employeeId)){
        // console.log('First unread is the current one: ' + this.info.id );
        return this;
      }
    }else{

      /*
      MemoAuthored by current employee.
      if (!this.isMemoReadByEmployee(employeeId)){
//        console.log('Memo has been authored by the current employee and not read: ' + this.info.id);
        return this;
      }
      */
    }

    this.related.sort(   (a: MemoAggregation, b: MemoAggregation) =>  {
      let resN: number = 0;
      if (moment(a.info.created).isAfter(moment(b.info.created))) {
        resN = 1;
      }
      if (moment(a.info.created).isAfter(moment(b.info.created))) {
        resN = -1;
      }
      return resN;
    });

    for (const bean of this.related){
      // console.log('Trying to find the first unread in the related messages');
      const tmp = bean.getFirstUnRead(employeeId);
      if (tmp!=null){
        return tmp;
      }
    }
    return null;
  }


  isMemoDeletedByEmployee (employeeId: string): boolean {
    let res: boolean = false;
    const mr = this.findRecipient(employeeId);
    if (mr) {
      res = mr.deleted;
    }
    if (!res) {
      for (const ms of this.status) {
        if (ms.employeeCode === employeeId) {
          if (MemoEmployeeStatusType.DELETED === ms.statusType ) {
            return true;
          }
        }
      }
    }
    return res;
  }

  /*
   SEEN("SEEN"),
   SEEN_PUNCH("SEEN_PUNCH"),
   READ("READ"),
   DELETED("DELETED");
   */

  isMemoReadByEmployee(employeeId: string): boolean {
    for (let ms of this.status) {
      // console.log('1) StatusType: ' + ms.statusDate + ' ' + ms.statusType + ' ' + ms.memoId + ' ' + ms.employeeCode);
      if (ms.employeeCode === employeeId) {
        // console.log('2) StatusType: ' + ms.statusDate + ' ' + ms.statusType + ' ' + ms.memoId);

        if (MemoEmployeeStatusType.READ === ms.statusType ) {
          return true;
        }
        if (MemoEmployeeStatusType.SEEN === ms.statusType ) {
          return true;
        }
        if (MemoEmployeeStatusType.SEEN_PUNCH === ms.statusType ) {
          return true;
        }
      }
    }
    return false;
  }

  isWrittenOrReadByEmployee(employeeId: string): boolean {
    if (this.info.fromCode === employeeId){
      return true;
    }
    for (let ms of this.status) {
      if (ms.employeeCode === employeeId) {
        if (MemoEmployeeStatusType.READ === ms.statusType ) {
          return true;
        }
      }
    }
    return false;
  }


  isReplyWrittenByEmployee(employeeId: string): boolean {
    for (const memo of this.related){
      if (memo.info.replyId === this.info.id){
        if (memo.info.fromCode === employeeId){
          return true;
        }
      }
    }
    return false;
  }


  isConsideredNewMemo(employeeId: string): boolean {
    let res = false;
    if (!this.isWrittenOrReadByEmployee(employeeId)){
      if (!this.isReplyWrittenByEmployee(employeeId)){
        res = true;
      }
    }
    if (!res){
      for (const memo of this.related){
        if (!memo.isWrittenOrReadByEmployee(employeeId)){
          if (!this.isReplyWrittenByEmployee(employeeId)){
            return true;
          }
        }
      }
    }
    return res;
  }




isMemoAuthoredBy(employeeId: string): boolean {
    if (this.info.fromCode===employeeId){
      return true;
    }
    return false;
  }

  retrieveAllDistinctRecipients(): Map<string,MemoEmployee>{
    const res = new Map<string,MemoEmployee>();
    this._retrieve(res);
    return res;
  }

  private _retrieve(map: Map<string,MemoEmployee>){
    if (!map.has(this.info.fromCode)){
      const me = new MemoEmployee();
      me.employeeCode = this.info.fromCode;
      me.employeeFullName = this.info.fromName;
      map.set(me.employeeCode,me);
    }
    for (const bean of this.recipients){
      if (!map.has(bean.employeeCode)){
        map.set(bean.employeeCode,bean);
      }
    }
    for (const rel of this.related){
      rel._retrieve(map);
    }
  }
  /*
  addReadStatusForEmployeeRecursive(employeeId: string): MemoEmployeeStatusType[]{
    const res = new Array<MemoEmployeeStatus>();
    res.push(...this.addReadStatusForEmployee(employeeId));
    for ()

    return res;
  }
  */

  addReadStatusForEmployee(employeeId: string): MemoEmployeeStatus[]{
    return this.addCustomStatusForEmployee(employeeId,MemoEmployeeStatusType.READ);
  }


  addCustomStatusForEmployee(employeeId: string, status: MemoEmployeeStatusType): MemoEmployeeStatus[]{
    const res = new Array<MemoEmployeeStatus>();
    const bean = new MemoEmployeeStatus();
    bean.employeeCode = employeeId;
    bean.statusType = status;
    bean.statusDate = moment().toDate();
    bean.memoId = this.info.id;
    res.push(bean);

    for (const bean of this.related){
      res.push(...bean.addCustomStatusForEmployee(employeeId,status));
    }

    return res;
  }

  addDeleteStatusForEmployee(employeeId: string): MemoEmployeeStatus[]{
    return this.addCustomStatusForEmployee(employeeId,MemoEmployeeStatusType.DELETED);
  }




  createReply(fromEmployeeId: string, fromEmployeeName: string): MemoAggregation {
    const replyMemo = new MemoAggregation();
    replyMemo.info = new MemoInformation();
    replyMemo.info.created = moment().toDate();
    replyMemo.info.replyId = this.info.id;
    replyMemo.info.threadId = this.info.threadId;
    replyMemo.info.type = MemoInformationType.PLAIN;

    if (this.info.threadId <= 0 ) {
      replyMemo.info.threadId = this.info.id;
    }

    // this.replyMemo.info.title = 'Re: ' + memo.info.title;
    replyMemo.info.title = this.info.title;
    // Generating the list of recipients (Removing ourself and adding the owner of the message)
    for (let recpt of this.recipients) {
      if (recpt.employeeCode !== fromEmployeeId ){
        let copy = new MemoEmployee();
        copy.employeeCode = recpt.employeeCode;
        copy.employeeFullName = recpt.employeeFullName;
        copy.deleted = false;
        replyMemo.recipients.push(copy);
      }
    }
    let copy = new MemoEmployee();
    copy.employeeCode = this.info.fromCode;
    copy.employeeFullName = this.info.fromName;
    copy.deleted = false;
    replyMemo.recipients.push(copy);

    replyMemo.info.fromCode = fromEmployeeId;
    replyMemo.info.fromName = fromEmployeeName;
    replyMemo.info.content = '\n--\n' + this.info.content;

    return replyMemo;
  }

}

export class MemoAttachment<T>{
    memoId: number;
    data: T;
}

export class MemoInformation{
  id: number;
  replyId: number;
  threadId: number;
  fromCode: string; // FromEmployeeId;
  fromName: string; // From EmployeeName;
  type : MemoInformationType;
  exp: Date; // Expiration Dt
  active: boolean = true;
  created: Date;
  title: string;
  content: string;
  visibleOnPunch : boolean = false;
  tagId:number;
  typeRefId: number; // contains link to ApprovableWorkShift
  mustBeAcknowledged = false;

  _createSpecialElement(propertyName: string, data: any) {
    if ('type' === propertyName) {
      this.type = MemoInformationType.retrieveFromCode(data);
      return true;
    }
    return false;
  }

}
export class MemoEmployeeStatus{

  id = -1;
  memoId: number;
  employeeCode: string;
  statusType: MemoEmployeeStatusType;
  statusDate: Date;
  employeeFullName: string;

  constructor () {
    this.resetId();
  }

  resetId(){
    this.id = -1 * Math.floor(Math.random() * Number.MAX_SAFE_INTEGER);
  }

  _createSpecialElement(propertyName: string, data: any) {
    if ('statusType' === propertyName) {
      this.statusType = MemoEmployeeStatusType.retrieveFromCode(data);
      return true;
    }
    return false;
  }
}

export class MemoEmployee{
  memoId: number;
  employeeCode: string;
  employeeFullName: string;
  deleted: boolean;
  messageIdForPunch: number;
}

export class MemoInformationType extends CustomCode{
  public static _registered = new Map<string, MemoInformationType>();
  static REQUEST_FAMILY_DAY = new MemoInformationType('REQUEST_FAMILY_DAY');
  static REQUEST_VACATION = new MemoInformationType('REQUEST_VACATION');
  static REQUEST_BANK_TYPE = new MemoInformationType('REQUEST_BANK_TYPE');
  static WORK_SHIFT = new MemoInformationType('WORK_SHIFT');
  static WORK_SHIFT_EXCHANGE = new MemoInformationType('WORK_SHIFT_EXCHANGE');
  static AVAILABILITIES_SE = new MemoInformationType('AVAILABILITIES_SE');
  static AVAILABILITIES_PERIODIC = new MemoInformationType('AVAILABILITIES_PERIODIC');
  static PLAIN = new MemoInformationType('PLAIN');

  static ALL = Array.from(MemoInformationType._registered.values());


  constructor (code: string) {
    super(code);
    MemoInformationType._registered.set(code, this);
  }

  public toTranslateKey(): string{
    return 'MEMO_INFO_TYPE_' + this.code;
  }


  static retrieveFromCode(code: string): MemoInformationType {
    const res = MemoInformationType._registered.get(code);
    if (!res) {
      console.log('MemoInformationType can\'t be found with code: ' + code);
      return null;
    }
    return res;
  }


}

export class MemoEmployeeStatusType extends CustomCode{
  public static _registered = new Map<string, MemoEmployeeStatusType>();
  static SEEN = new MemoEmployeeStatusType('SEEN');
  static SEEN_PUNCH = new MemoEmployeeStatusType('SEEN_PUNCH');
  static READ = new MemoEmployeeStatusType('READ');
  static DELETED = new MemoEmployeeStatusType('DELETED');
  // static ACKNOWLEDGED = new MemoEmployeeStatusType('ACKNOWLEDGED');

  static ALL = Array.from(MemoEmployeeStatusType._registered.values());


  constructor (code: string) {
    super(code);
    MemoEmployeeStatusType._registered.set(code, this);
  }

  public toTranslateKey(): string{
    return 'MEMO_EMP_STATUS_' + this.code;
  }


  static retrieveFromCode(code: string): MemoEmployeeStatusType {
    const res = MemoEmployeeStatusType._registered.get(''+code);
    if (!res) {
      console.log('MemoEmployeeStatusType can\'t be found with code: ' + code);
      return null;
    }
    return res;
  }


}

